import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogsService } from '../../../services/catalogs.services';
import { IProduct } from 'src/app/features/produits/models/products.models';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { LoadMoreCatalogProducts } from '../../../store/catalogs.actions';
import { IPagination } from 'src/app/shared/models/page.model';
import { HasPermissionContext } from 'src/app/shared/has-permission.directive';

@Component({
  selector: 'app-new-catalog-products',
  templateUrl: './new-catalog-products.component.html',
  styleUrls: ['./new-catalog-products.component.scss']
})
export class NewCatalogProductsComponent implements OnInit, OnDestroy {
  source: 'agents' | 'catalogs' = 'catalogs';
  agentId!: number;
  catalogtId!: number;
  products: IProduct[] = [];
  pricingRules: any = null;
  productsMetadata: IPagination | null = null;
  isLoadingMore: boolean = false;
  private currentPage: number = 1;
  private pageSize: number = 25;
  private destroy$ = new Subject<void>();
  @Input() currencyControl = new FormControl();

  productsMetadata$: Observable<IPagination | null> = this.store.select(
    (state) => state.catalogs.productsMetadata
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private catalogService: CatalogsService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.source = this.router.url.includes('agents') ? 'agents' : 'catalogs';
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.agentId = params['agentId'];
    });
    this.route.params.subscribe(params => {
      if(this.source === 'catalogs') {
        this.catalogtId = Number(params['id']);
      }
    });

    // Subscribe to products metadata for pagination
    this.productsMetadata$.pipe(takeUntil(this.destroy$)).subscribe((metadata) => {
      this.productsMetadata = metadata;
      if (metadata) {
        this.currentPage = metadata.page || 1;
      }
      this.isLoadingMore = false;
    });

    // Subscribe to reactive data so late-loaded details reflect here
    this.catalogService.newCatalogData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (!data) { return; }
        if (data?.products && data.products.length > 0) {
          this.products = data.products;
        } else {
          this.products = [];
        }

        this.pricingRules = {
          pricing_rule: data.pricing_rule,
          overall_pricing_value: data.overall_pricing_value,
          extra_discount: data.extra_discount
        };
      });
  }

  addNewProducts() {
    if (this.source === 'agents') {
      if(this.catalogtId) {
        this.router.navigate(['/agents', 'edit-catalog', 'add-products', this.catalogtId], { queryParams: { agent_id: this.agentId } });
      }
      else {
        this.router.navigate(['/agents', 'new-catalog', 'add-products'], { queryParams: { agent_id: this.agentId } });
      }
    } else {
      if(this.catalogtId) {
        this.router.navigate(['/catalogs', 'edit-catalog', this.catalogtId, 'add-products']);
      } else {
        this.router.navigate(['/catalogs', 'new-catalog', 'add-products']);
      }
    }
  }

  loadMore() {
    if (this.isLoadingMore || !this.productsMetadata || !this.catalogtId) {
      return;
    }

    // Check if there are more products to load
    if (this.products.length >= (this.productsMetadata.count || 0)) {
      return;
    }

    this.isLoadingMore = true;
    const nextPage = this.currentPage + 1;
    this.store.dispatch(LoadMoreCatalogProducts({
      id: this.catalogtId,
      page: nextPage,
      limit: this.pageSize
    }));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  submitPermission(): HasPermissionContext {
    return { module: 'catalog', action: this.catalogtId ? 'edit' : 'create' };
  }
}
